<div class="stake-input-container" [ngClass]="{ disabled: disabled }">
    <vn-icon
        name="theme-error-i"
        class="numpad-theme-error stake-input"
        [size]="isEpcotEnabled ? '16' : '12'"
        [class.icon-allignment]="isEpcotEnabled"
        (click)="onFocus()" />
    @if (adornmentStart) {
        <span class="stake-input-adornment stake-input-adornment--start">{{ adornmentStart }}</span>
    }
    <input
        #inputRef
        class="stake-input-value"
        type="text"
        msValidateStakeInput
        autocomplete="off"
        [placeholder]="emptyCharacter"
        [attr.disabled]="disabled ? '' : null"
        (focus)="onFocus()"
        (paste)="onPaste($event)"
        (keyup)="onKeyUp($event)"
        (blur)="onBlur()" />
</div>
